<template>
    <div class="row marketGasExpired-row">
        <div class="control-sectionGasExp">
            <h5 id="gasTitleExp">Gas Expired</h5>
            <div class="form-row form-row-gas">
                <div class="form-group col-md-3">
                    <ejs-dropdownlist ref="dplTradablePeriodGasExp" id='tradablePeriodExp' name="tradablePeriodExp" :change='onPeriodGasExp' :index="selectDefault" :enabled="true" floatLabelType="Auto" :dataSource='tradablePeriodsExp' :fields="{text: 'name', value: 'id' }" placeholder="Tradeable Period"></ejs-dropdownlist>
                </div>
                <div class="form-group col-md-3">
                    <ejs-dropdownlist ref='dplYearGasExp' id="yearGasExp" name="yearGasExp" :enabled="true" :change='onYearGasExp' :index="selectDefault" v-model="selectedYearGasExp" :dataSource='yearGasExp' placeholder="Year" floatLabelType='Auto'></ejs-dropdownlist>
                </div>
                <div class="form-group col-md-3">
                    <ejs-dropdownlist ref='dplStateGasExp' id="stateGasExp" name="stateGasExp" :change='onStateGasExp' v-model="selectedStateGasExp" :index="selectDefault" :enabled="true" :dataSource='stateDataGasExp' :fields="{text: 'name', value: 'id' }" placeholder="State - Price Area" floatLabelType='Auto'></ejs-dropdownlist>
                </div>
            </div>
            <div id="noDataGasExp" ref="noDataGasExp" class="chartGasNoDataExp" align='center'>
                <img src="../../../../public/img/NoData.jpg" />
            </div>
            <div class="chartGasExp" align='center'>
                <ejs-stockchart id="stockchartcontainerGasExp"
                                width='80%'
                                :primaryXAxis="primaryXAxis"
                                :primaryYAxis="primaryYAxis"
                                :crosshair="crosshair"
                                ref="schGasExp"
                                :title="title"
                                :tooltip="tooltip"
                                :enableSelector="enableSelector"
                                :trendlineType="trendlineType"
                                :indicatorType="indicators"
                                :seriesType="seriesType"
                                :theme="theme">
                    <e-stockchart-periods>
                        <e-stockchart-period intervalType="Months" interval="1" text="1M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Months" interval="3" text="3M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Months" interval="6" text="6M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Years" interval="1" text="1Y" selected="true"></e-stockchart-period>
                        <e-stockchart-period text="YTD"></e-stockchart-period>
                        <e-stockchart-period text="All"></e-stockchart-period>
                    </e-stockchart-periods>
                    <e-stockchart-series-collection>
                        <e-stockchart-series :dataSource="seriesDataGasExp" type="Spline" xName='date' yName="price" fill="#485696"></e-stockchart-series>
                    </e-stockchart-series-collection>
                </ejs-stockchart>
            </div>
            <div id="hiddenDivGasExp" style="display: none;" class="__web-inspector-hide-shortcut__">
                <ejs-grid id="chartHiddendataGasExp"
                          :dataSource="chartHiddenSourceGasExp"
                          ref="chartHiddenGridGasExp"
                          :allowPaging="true"
                          :pageSettings='pageSettings'
                          :allowExcelExport='true'
                          :toolbarClick='toolbarClickGasExp'
                          :toolbar='toolbarOptionsGasExp'
                          :visible="false">
                    <e-columns>
                        <e-column field='id' :disableHtmlEncode='false' headerText='Id' :isPrimaryKey='true' :visible="false" textAlign='Left'></e-column>
                        <e-column field='ricName' :disableHtmlEncode='false' headerText='Ric' textAlign='Left' width="100px"></e-column>
                        <e-column field='priceAreaName' :disableHtmlEncode='false' headerText='State - Price Area' textAlign='Left' width="120px"></e-column>
                        <e-column field='productName' :disableHtmlEncode='false' headerText='Product' textAlign='Left' width="120px"></e-column>
                        <e-column field='periodName' :disableHtmlEncode='false' headerText='Period' textAlign='Left' width="120px"></e-column>
                        <e-column field='date' :disableHtmlEncode='false' headerText='Date' :format='dateFormatOptions' type="date" textAlign='Left' width="120px"></e-column>
                        <e-column field='price' :disableHtmlEncode='false' headerText='Price' textAlign='Left' width="100px"></e-column>
                        <e-column field='tradingUnitName' :disableHtmlEncode='false' headerText='Unit' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="btn-excelExp">
                <ejs-button id="gasExpbtn" v-on:click.native='toolbarClickGasExp'>Export Data</ejs-button>
            </div>
            <div ref='spinnerEleGas' id="spinnerGas"></div>
        </div>
    </div>

</template>
<script>
    import Vue from "vue";
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import apis from '@/common/network';
    import urls from '@/common/urls';
    import dates from '@/common/dates';
    import periodConversion from '@/common/periodConversion';
    import {
        StockChartPlugin, DateTime, CandleSeries, RangeTooltip, LineSeries, SplineSeries,
        HiloOpenCloseSeries, HiloSeries, RangeAreaSeries, Trendlines, EmaIndicator, RsiIndicator, BollingerBands,
        TmaIndicator, MomentumIndicator, SmaIndicator, AtrIndicator, Crosshair, AccumulationDistributionIndicator, MacdIndicator, StochasticIndicator, Export, Tooltip
    } from "@syncfusion/ej2-vue-charts";
    import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import SyncHelper from '@/common/syncfusion';
    import { GridPlugin, Page, Selection, RowDD, Toolbar, ExcelExport } from "@syncfusion/ej2-vue-grids";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';


    Vue.use(ButtonPlugin);
    Vue.use(StockChartPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(GridPlugin);

    let selectedTheme = location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : "Material";
    let theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark");

    export default Vue.extend({
        created() {
            this.populateYearsGasExp("Calendar", "Gas");
            this.populateGasStateAndRicId("Calendar", "Gas", new Date().getFullYear()-1);
        },
        data: function () {

            return {
                mppdDateVal: dates.addDays(new Date(), -1),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                selectDefault: 0,
                yearGasExp: [],
                selectedYearGasExp: 0,
                selectedStateGasExp: 0,
                seriesDataGasExp: [],
                stateDataGasExp: [],
                chartHiddenSourceGasExp: [],
                toolbarOptionsGasExp: ['Export Data'],
                selection: { type: 'Multiple' },
                pageSettings: { pageSize: 8 },
                theme: theme,
                //Initializing Primary X Axis
                primaryXAxis: {
                    visible: true,
                    valueType: 'DateTime'


                },
                //Initializing Primary Y Axis
                primaryYAxis:
                {
                    visible: true,
                    majorTickLines: { color: "transparent", width: 0 },
                    labelPosition: 'Outside'

                },

                enableSelector: true,
                trendlineType: [],
                indicators: [],
                seriesType: [],
                theme: 'Bootstrap',
                tooltip: {
                    enable: true, header: ' ',
                    format: '<b>${point.x} : ${point.y}</b>'
                },

                crosshair: { enable: true },
                chartArea: {
                    border: {
                        width: 0
                    }
                },

                title: " ",
                palettes: ["#001c55", "#8f857d"]
            };
        },

        provide: {
            stockChart: [
                DateTime, Crosshair, RangeTooltip, LineSeries, SplineSeries, CandleSeries, HiloOpenCloseSeries, HiloSeries, RangeAreaSeries, Trendlines, EmaIndicator, RsiIndicator,
                BollingerBands, TmaIndicator, MomentumIndicator, SmaIndicator, AtrIndicator, AccumulationDistributionIndicator, MacdIndicator, StochasticIndicator, Export, Tooltip
            ],
            grid: [Page, Selection, RowDD, Toolbar, ExcelExport]
        },
        mounted() {
            //createSpinner({ target: this.$refs.spinnerEleGas });
            //showSpinner(this.$refs.spinnerEleGas);
        },
        methods: {
            toolbarClickGasExp: function (args) {

                let excelExportProperties = {
                    fileName: "Export Chart Gas Expired.xlsx",
                    theme:
                    {
                        header: {
                            fontName: 'Arial', fontColor: '#001c55'
                        },
                        record: {
                            fontName: 'Arial', fontColor: '#4d4d4d'
                        },
                        caption: {
                            fontName: 'Arial', fontColor: '#4d4d4d'
                        }
                    }

                };
                this.$refs.chartHiddenGridGasExp.excelExport(excelExportProperties);

            },
            onYearGasExp: function (args) {
                if (args.isInteracted == true) {
                    showSpinner(document.getElementById('mainSpinner'));
                }
                var product = "Gas";
                var ricId = this.$refs.dplStateGasExp.ej2Instances.itemData.id;
                if (ricId != undefined && args.value != null) {
                    var splitPeriod = args.value.split('-');
                    var indicatorSplit = splitPeriod[0];

                        var indicator = "";
                        if (indicatorSplit.includes("Q")) {
                            indicator = indicatorSplit;
                        } else {
                            indicator = periodConversion.convertPeriod(indicatorSplit);
                        }
                        const year = parseInt(new Date().getFullYear().toString().slice(0, 2) + splitPeriod[1]);
                        this.fetchGasDataChartExp(ricId, indicator, year, product);
                }
                hideSpinner(document.getElementById('mainSpinner'))
            },
            onStateGasExp: function (args) {
                if (args.isInteracted == true) {
                    showSpinner(document.getElementById('mainSpinner'));
                    var product = "Gas"
                    var yearPeriodExp = this.$refs.dplYearGasExp.ej2Instances.itemData;
                    var splitPeriod = yearPeriodExp.split('-');


                    var indicatorSplit = splitPeriod[0];
                    var indicator = "";
                    if (indicatorSplit.includes("Q")) {
                        indicator = indicatorSplit;
                    } else {
                        indicator = periodConversion.convertPeriod(indicatorSplit);
                    }


                    const year = parseInt(new Date().getFullYear().toString().slice(0, 2) + splitPeriod[1]);
                    this.fetchGasDataChartExp(args.itemData.id, indicator, year, product);
                }

            },
            checkPermissionOnUser: function () {
                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {

                        document.getElementById("gasExpbtn").style.display = 'none';
                    }

            },
            populateGasStateAndRicId(indicator, product, year) {
                showSpinner(document.getElementById('mainSpinner'))
                apis.protectedApi(`${urls.apiBaseUrl}utils/getSateExpMarket?date=${this.mppdDateVal.toISOString().split('T')[0]}&year=${year}&indicator=${indicator == undefined ? "Y" : indicator}&product=${product == undefined ? "Baseload" : product}`).then(state => {

                    let temp = [];
                    for (var i = 0; i < state.data.result.length; i++) {

                        temp.push(state.data.result[i]);

                    }
                    this.stateDataGasExp = temp;

                    if (this.selectedStateGasExp == 0) {
                        setTimeout(() => {
                            this.selectedStateGasExp = this.stateDataGasExp[0].id;
                        }, 1000)
                       
                    }
                    this.checkPermissionOnUser();
                    hideSpinner(document.getElementById('mainSpinner'));
                    /*hideSpinner(this.$refs.spinnerEleGas);*/
                }).catch(
                    response => {
                        this.handleError(response);
                        /*hideSpinner(this.$refs.spinnerEleGas);*/
                        hideSpinner(document.getElementById('mainSpinner'));


                    }
                   

                );

            },
            fetchGasDataChartExp(id, indicator, year, product) {
                apis.protectedApi(`${urls.apiBaseUrl}MarketPricingPerDay/FromDateChart?date=${this.mppdDateVal.toISOString().split('T')[0]}&id=${id}&indicator=${indicator}&year=${year}&product=${product}`).then(fxr => {
                    let temp = [];
                    let tempChartGasExp = [];
                    for (var i = 0; i < fxr.data.result.length; i++) {
                        temp.push(fxr.data.result[i]);

                        let chartRateGasExp = {

                            id: fxr.data.result[i].ricId,
                            ricName: fxr.data.result[i].fullRicName,
                            stateName: fxr.data.result[i].stateName,
                            priceAreaName: fxr.data.result[i].priceAreaName,
                            productName: fxr.data.result[i].productName,
                            periodName: fxr.data.result[i].periodSpanName == null ? fxr.data.result[i].periodName : fxr.data.result[i].periodSpanName,
                            price: fxr.data.result[i].price.toFixed(3),
                            tradingUnitName: fxr.data.result[i].tradingUnitName,
                            date: new Date(fxr.data.result[i].date)
                        }
                        tempChartGasExp.push(chartRateGasExp);
                    }
                    if (temp.length == 0) {
                        this.$refs.schGasExp.$el.style.display = "none";
                        document.getElementById("noDataGasExp").style.display = "block";

                    } else {
                        this.$refs.schGasExp.$el.style.display = "block";
                        document.getElementById("noDataGasExp").style.display = "none";
                    }
                    this.seriesDataGasExp = temp;
                    this.chartHiddenSourceGasExp = tempChartGasExp;
                    hideSpinner(document.getElementById('mainSpinner'));
                    /*hideSpinner(this.$refs.spinnerEleGas);*/
                }).catch(
                    response => {
                        this.handleError(response);
                        /*hideSpinner(this.$refs.spinnerEleGas);*/
                        hideSpinner(document.getElementById('mainSpinner'));

                    }
             
                );

            },
            onPeriodGasExp: function (args) {
                showSpinner(document.getElementById('mainSpinner'));
                var period = this.$refs.dplYearGasExp;
                var indicator = '';
                var product = "Gas";
                if (args.itemData.name == 'Calendar') {
                    indicator = 'Y';
                    period.ej2Instances.placeholder = "Select Year";
                }
                if (args.itemData.name == 'Month') {
                    indicator = 'M';
                    period.ej2Instances.placeholder = "Select Month";
                }
                if (args.itemData.name == 'Quarter') {
                    indicator = 'Q';
                    period.ej2Instances.placeholder = "Select Quarter";
                }
                if (args.itemData.name == 'Season') {
                    indicator = 'S';
                    period.ej2Instances.placeholder = "Select Season";
                }
                this.populateYearsGasExp(args.itemData.name, product);
            },
            populateYearsGasExp: function (indicator, product) {
                showSpinner(document.getElementById('mainSpinner'))
                apis.protectedApi(`utils/productYearsExp?date=${this.mppdDateVal.toISOString().split('T')[0]}&indicator=${indicator}&product=${product == undefined ? "Gas" : product}`)
                    .then(response => {
                        let temp = [];
                        for (var i = 0; i < response.data.length; i++) {
                            if (response.data[i].name == "Calendar") {
                                response.data[i].name = "CAL"
                            }

                            if (response.data[i].periodName == "Month" || response.data[i].periodName == "Season") {
                                response.data[i].name = response.data[i].name.slice(0, 3);
                            }
                            var yearString = response.data[i].year.toString();
                            var yearSlice = yearString.slice(2);
                            var name = response.data[i].name + "-" + yearSlice;

                            temp.push(name);
                        }
                        this.yearGasExp = temp;
                        if (this.selectedYearGasExp == 0) {
                            setTimeout(() => {
                                this.selectedYearGasExp = this.yearGasExp[0];
                            }, 1000)
                          
                        }
                        hideSpinner(document.getElementById('mainSpinner'));
                        /*hideSpinner(this.$refs.spinnerEleGas);*/
                    }).catch(e => {
                       /* hideSpinner(this.$refs.spinnerEleGas);*/
                        hideSpinner(document.getElementById('mainSpinner'));
                    });

            },


        },
        computed: {

            tradablePeriodsExp() {
                return SyncHelper.getDataManager("utils/Tradableperiods");
            },

        }

    });
</script>
<style>
    #stockchartcontainerGasExp_stock_border {
        width: 80% !important;
    }

    #stockchartcontainerGasExp_Secondary_Element {
        width: 96%;
    }

    @media screen and (max-width: 1746px) {
        #stockchartcontainerGasExp_Secondary_Element {
            width: 80%;
        }
    }

    .fx-price-padding {
        padding-top: 30px;
    }

    .control-sectionGasExp {
        border: 1px solid lightgrey;
        border-radius: 5px;
        margin: 5px 0px 25px 10px;
        width: 100%;
    }

    #gasRatesMarket {
        width: 450px;
    }

    .form-row-gas {
        margin: 0px 5px 0px 5px;
    }
    #gasTitleExp{
        padding: 10px 0px 0px 10px;
    }
    #stockchartcontainerGasExp_stock_border {
        border: 0px solid rgb(221, 221, 221) !important;
    }

    .form-row-gas {
        display: flex;
        margin: 0px 5px 0px 5px;
    }
    .chartGasNoDataExp{
        display: none;
    }
    .parentMarketExpired{
        background-color: white;
    }
    .marketGasExpired-row {
        display: flex;
        background-color: white;
        padding: 25px 0px 10px 15px;
        margin-left: 5px;
    }
    .e-toolbar-right > div:nth-child(3) {
        display: none !important;
    }

</style>